import jQuery from 'jquery';
import 'jquery-validate';
import '@shared/facebook-connect';
import retargetingTracking from '@shared/tracking-retargeting';
import { getCookie, setCookie, setReferralCookie } from '@shared/cookie';
import { getQueryStringValueByName } from '@shared/url';
import { cookieBase } from 'server-data/flconfigs';
import signupForm from './components/pinhp-legacy/signup-form.js';
import skillsLoader from './components/pinhp-legacy/skills-loader.js';
import stateManager from './components/pinhp-legacy/state-manager.js';
import loginForm from './components/pinhp-legacy/login-form.js';
import forgotPasswordForm from
  './components/pinhp-legacy/forgot-password-form.js';
import heroSliderFactory from './components/hero-slider';

const signupAsFreelancerRadioEl = document.getElementById('looking_for_work');
const signupAsEmployerRadioEl = document.getElementById('looking_to_hire');

setReferralCookie();
stateManager.init({
  onHeroSectionToggled(event) {
    if (event.currentTarget.id === 'work-signup-link') {
      signupAsFreelancerRadioEl.checked = true;
    } else {
      signupAsEmployerRadioEl.checked = true;
    }
  },
});
skillsLoader.init();
loginForm.init();
forgotPasswordForm.init();
signupForm.init();

// Log login attempts to QTS
jQuery('#login-bt').on('click', () => {
  const eventArr = { event: 'Front Page Log In' };
  _lt.push(eventArr);
});

const coupon = getQueryStringValueByName('coupon');
if (typeof coupon === 'string' && coupon !== '') {
  setCookie(`${cookieBase}_COUPON`, coupon, 31);
}

jQuery('#signup-coupon')
    .val(getCookie(`${cookieBase}_COUPON`));

// Coupon toggle in signup
jQuery('#redeem_coupon').click(() => {
  jQuery('#coupon_div').toggle();
  return false;
});

jQuery('[data-action="hire-section"]').click(() => {
  retargetingTracking.paTrack2('track', 'FrontHire');
  retargetingTracking.fbTrack2('track', 'FrontHire');
});

jQuery('[data-action="work-section"]').click(() => {
  retargetingTracking.paTrack2('track', 'FrontWork');
  retargetingTracking.fbTrack2('track', 'FrontWork');
});

if (window.performance && window.performance.mark) {
  window.performance.mark('homepage_js_ready');
}

// Include csrf_token into all AJAX requests.
jQuery.ajaxPrefilter((options, originalOptions, jqXHR) => {
  const xsrfToken = getCookie('XSRF-TOKEN');
    // set the header for ALL ajax
  jqXHR.setRequestHeader('X-XSRF-TOKEN', xsrfToken);
});

const slidesList = document.querySelectorAll('[data-hero="slide"]');
const slideControlsList = Array.from(
  document.querySelectorAll('[data-hero="slide-control"]'));

// Initialize the hero slider and the controls click handler
// TODO: This part badly needs a refactor. The way the sliders and the
// clickable controls work together is just pure hackiness and can be
// abstracted away in a module.
const heroSlider = heroSliderFactory(slidesList, {
  onSlideSwitched: (previousPaneIndex) => {
    slideControlsList[previousPaneIndex].classList.remove('is-selected');
    slideControlsList[heroSlider.getActiveSlideIndex()]
      .classList.add('is-selected');
  },
});
slideControlsList.forEach((control) => {
  control.addEventListener('click', (event) => {
    const clickedControlIndex = slideControlsList
      .findIndex(controlEl => controlEl === event.target);
    // Switch slider
    heroSlider.switchToSlide(clickedControlIndex);
    // Restart slideshow timer
    heroSlider.stopSlideshow();
    heroSlider.startSlideshow(5000);
  });
});
heroSlider.startSlideshow(5000);

// If fb-connect gets an error, hide login with Facebook Button and
// hr separators
window.fbAsyncInitLoadError = () => {
  jQuery('.gaf-fb-connected-button').hide();
  jQuery('#login-form-facebook-separator').hide();
  jQuery('#signup-form-facebook-separator').hide();
  jQuery('#work-facebook-separator').hide();
};
